import * as Yup from 'yup';
import { t } from 'i18next';

export const OrderSelectSchema = () => Yup.object().shape({
    selectOrder: Yup.string()
        .required(t('validation.required')),
});
